import { render } from "./AddHouseModal.vue?vue&type=template&id=cb61e8f0&scoped=true"
import script from "./AddHouseModal.vue?vue&type=script&lang=js"
export * from "./AddHouseModal.vue?vue&type=script&lang=js"

import "./AddHouseModal.vue?vue&type=style&index=0&id=cb61e8f0&lang=scss&scoped=true"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb61e8f0"]])

export default __exports__